import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "./Icon.js";

export function TabBar() {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const active = pathname.startsWith("/orders")
    ? "orders"
    : pathname.startsWith("/profile")
      ? "profile"
      : "home";

  return (
    <div className="tabbar">
      <button data-active={active === "home"} onClick={() => nav("/")}>
        <Icon name="home" size={22} /> Главная
      </button>
      <button data-active={active === "orders"} onClick={() => nav("/orders")}>
        <Icon name="list" size={22} /> Заказы
      </button>
      <button data-active={active === "profile"} onClick={() => nav("/profile")}>
        <Icon name="user" size={22} /> Профиль
      </button>
    </div>
  );
}
